// extracted by mini-css-extract-plugin
export default {"button":"Button_button__uhH4J","secondary":"Button_secondary__AFrB6"};